import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationCaseTypeLaboratoryPatchInBatchRequest, ConfigurationCaseTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class CaseTypeLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationCaseTypeLaboratoryResponse>> {
        const response = await axios.put(`/configuration/laboratories/${laboratoryId}/caseTypeLaboratories`, filterModel, { params })
        return response.data
    }

    async getCaseTypeLaboratoryById(laboratoryId: number, caseTypeLaboratoryId: number): Promise<ConfigurationCaseTypeLaboratoryResponse> {
        const response = await axios.get(`/configuration/laboratories/${laboratoryId}/caseTypeLaboratories/${caseTypeLaboratoryId}`)
        return response.data
    }

    async createCaseTypeLaboratory(laboratoryId: number, request: ConfigurationCaseTypeLaboratoryPatchInBatchRequest): Promise<ConfigurationCaseTypeLaboratoryResponse> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/caseTypeLaboratories`, request)
        return response.data
    }

    async deleteCaseTypeLaboratory(laboratoryId: number, caseTypeLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/caseTypeLaboratories/batch`, { data: caseTypeLaboratoryIds })
        return response.data
    }

    async patchCaseTypeLaboratory(laboratoryId: number, requests: ConfigurationCaseTypeLaboratoryPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch(`/configuration/laboratories/${laboratoryId}/caseTypeLaboratories/batch`, requests)
        return response.data
    }
}

export const caseTypeLaboratoriesConfigurationServices = new CaseTypeLaboratoriesConfigurationServices()
